import { customAxios } from '../../common/customAxios';
import { usersOwnTractorsApiUrl } from '../queries/getUsersOwnTractors';

interface deletePokeToUserOwnTractorParams {
  tractorId: string;
}

export const deletePokeToUserOwnTractor = ({ tractorId }: deletePokeToUserOwnTractorParams): Promise<void> => {
  return customAxios.delete(`${usersOwnTractorsApiUrl}/${tractorId}/pokes`);
};
